import { render } from "./Leads.vue?vue&type=template&id=697fb8f9"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"

import exportComponent from "/Users/susana/Local Sites/rhinodoors_dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__